module.exports = __webpack_public_path__ + "static/media/cmt_icon1.42d14097.png";